export const resourceProfileRebuildQueryRootKey = ["resource_profile_rebuild", "tasks"] as const;
